import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import * as cabinetActions from '../../actions/cabinet';
import * as setttingActions from '../../actions/settings';
import * as replenishPlanActions from '../../actions/replenishPlan';
import * as replenishRuleActions from '../../actions/replenishRule';
import * as productsActions from './../../actions/products';
import * as planogramActions from './../../actions/planogram';

import SignedInHeader from '../../components/signin/signedInHeader';
import Replenish from '../../components/replenish/replenish';
import ReplenishPlan from '../../components/replenish/replenishPlan';
import User from '../../components/common/user';
import Planogram from '../../components/replenish/planogram';

const ReplenishContainer = ({
  cabinetActions,
  settingActions,
  replenishPlanActions,
  replenishRuleActions,
  productsActions,
  cabinet,
  setting,
  replenishPlan,
  replenishRule,
  products,
  planogramActions,
  planogramConfig,
  t,
  match: {
    params: { deviceCode },
  },
}) => {
  const [activeNav, setActiveNav] = useState('refill');

  useEffect(() => {
    cabinetActions.fetchCabinetInfo(deviceCode);
    cabinetActions.fetchCabinetShelfConfig();
    settingActions.fetchCabinetSettings(deviceCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceCode]);

  useEffect(() => {
    if (cabinet.group) {
      replenishPlanActions.fetchPlan(cabinet.group, deviceCode);
      replenishRuleActions.fetchRule(cabinet.group, deviceCode);
      productsActions.fetchProducts(cabinet.group);
      planogramActions.fetchPlanogram(deviceCode, cabinet.group);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cabinet.group]);

  return (
    <section>
      <SignedInHeader
        setActiveNav={setActiveNav}
        activeNav={activeNav}
        t={t}
        cabinet={cabinet}
      />
      <div className="main-container">
        {activeNav === 'refill' && (
          <Replenish
            cabinetActions={cabinetActions}
            settingActions={settingActions}
            replenishPlanActions={replenishPlanActions}
            setting={setting}
            cabinet={cabinet}
            replenishPlan={replenishPlan}
            refillSchema={replenishRule}
            products={products}
            planogramConfig={planogramConfig}
            planogramActions={planogramActions}
            t={t}
            updateRefillStatus={() => setActiveNav('refillPlan')}
          />
        )}
        {activeNav === 'planogram' && (
          <Planogram
            replenishPlan={replenishPlan}
            refillSchema={replenishRule}
            t={t}
            products={products}
            cabinet={cabinet}
            cabinetActions={cabinetActions}
            planogramConfig={planogramConfig}
            cabinetSetting={setting}
          />
        )}
        {activeNav === 'refillPlan' && (
          <ReplenishPlan
            replenishPlan={replenishPlan}
            replenishRule={replenishRule}
            cabinetItems={cabinet.currentItems}
            currentItemsLoading={cabinet.currentItemsLoading}
            fetchCabinetItems={cabinetActions.handleFetchCabinetInventory}
            deviceCode={deviceCode}
            t={t}
            products={products}
            cabinet={cabinet}
            cabinetActions={cabinetActions}
          />
        )}
        {activeNav === 'user' && <User t={t} />}
        <img
          className="logo"
          src="https://cdn.selflystore.com/images-general/logos/selfly-logo.svg"
          alt="logo"
        />
      </div>
    </section>
  );
};

const mapStateToProps = ({
  cabinet,
  setting,
  replenishPlan,
  replenishRule,
  products,
  planogram,
}) => ({
  cabinet,
  setting,
  replenishPlan,
  replenishRule,
  products,
  planogramConfig: planogram,
});

const mapDispatchToProps = dispatch => ({
  cabinetActions: bindActionCreators(cabinetActions, dispatch),
  settingActions: bindActionCreators(setttingActions, dispatch),
  replenishPlanActions: bindActionCreators(replenishPlanActions, dispatch),
  replenishRuleActions: bindActionCreators(replenishRuleActions, dispatch),
  productsActions: bindActionCreators(productsActions, dispatch),
  planogramActions: bindActionCreators(planogramActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(ReplenishContainer));
